import { HttpError } from '@server/shared/errors/http'
import { HTTPException } from 'hono/http-exception'

const isValidationError = (error: unknown): error is HTTPException => {
  return error instanceof HTTPException && error.message.startsWith('Malformed')
}

const isError = (error: unknown): error is Error => {
  return error instanceof Error
}

const errorToObject = (error: Error) => {
  const errorObject = {
    type: error.constructor.name,
    message: error.message,
    stack: null, // stack은 숨김 처리 하기 위해 기본 값 설정
  }

  return Object.entries(error).reduce<Record<string, unknown>>((result, [key, value]) => {
    if (result[key] === undefined) {
      result[key] = value
    }
    return result
  }, errorObject)
}

export const getServerErrorFromUnknown = (error: unknown): HttpError => {
  if (error instanceof HttpError) {
    return error
  }

  if (isValidationError(error)) {
    return new HttpError(400, {
      code: 'INVALID_PARAMETER',
      message: 'Invalid request data. Please check the provided parameters.',
      reason: [error.message],
    })
  }

  if (isError(error)) {
    return new HttpError(500, {
      code: 'INTERNAL_SERVER_ERROR',
      message: 'This is temporary error. Please try again in a few minutes.',
      cause: errorToObject(error),
    })
  }

  return new HttpError(500, {
    code: 'INTERNAL_SERVER_ERROR',
    message: 'This is temporary error. Please try again in a few minutes.',
    cause: error,
  })
}
